import React, { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { GoAlert } from 'react-icons/go';
import { Button } from 'primereact/button';
import grupoTvService from '../../../../services/tvs/grupoTvService.js';
import { acoes } from '../helpers/objetosAuxiliares';
import { Growl } from 'primereact/growl';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';

export function ExcluirRegistro({
    rowSelecionada,
    modalAberto,
    setModalAberto,
    setRecarregarDataTable
}) {
    const mensagemToast = useRef(null);
       
    const fecharModal = () => setModalAberto(false);

    const inativarParametro = async dadosSelecionados => {
        try {
            await grupoTvService.deleteGrupo(dadosSelecionados);
            setRecarregarDataTable(true);
            mostrarMensagemSucesso(mensagemToast,'Grupo excluido com sucesso!');
            fecharModal();
        } catch {
            fecharModal();
            mostrarMensagemErro(mensagemToast,'Não foi possível excluir o grupo');
            throw new Error();
        }
    };

    const body = (
        <div
            style={{
                display: 'flex',
                gap: '8px',
                flex: '1',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <GoAlert size={80} color="black" />
            <h2>{acoes[rowSelecionada.Status]} Excluir grupo?</h2>
        </div>
    );

    const footer = (
        <div style={{ display: 'flex',
            gap: '8px',
            alignItems: 'center' }}>
            <p>Tem certeza que deseja fazer isso?</p>
            <Button
                className="p-button-success"
                label="Sim"
                onClick={() => inativarParametro(rowSelecionada)}
            />
            <Button className="p-button-danger" label="Não" onClick={fecharModal} />
        </div>
    );

    return (
        <>
            <Growl ref={mensagemToast} />            
            <Dialog
                dismissableMask
                visible={modalAberto}
                showHeader={false}
                onHide={fecharModal}
                footer={footer}
                position="bottom"
            >
                {body}
            </Dialog>
        </>
    );
}
